var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.allCocktails)?_c('v-row',_vm._l((_vm.allCocktails.filter(function (elem) {
            return (
          elem.strDrink.toLowerCase().includes(_vm.myFilter.toLowerCase()) || (
              elem.strDrinkFR && elem.strDrinkFR.toLowerCase().includes(_vm.myFilter.toLowerCase())))
        })),function(c){return _c('v-col',{key:c.idDrink,attrs:{"cols":"12","sm":"3"}},[_c('Cocktail',{attrs:{"cocktail":c}})],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }